import axios from 'axios'
import config from '../config/app'

const emailAPI = {
  get (filters, additionalFields) {
    let additional = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
    let filter = filters ? Object.keys(filters).map(function (key) {
      return key + '=' + filters[key]
    }).join('&') : ''
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/email-template?' + additional + filter).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/email-template/' + id, data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/email-template', data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default emailAPI



// WEBPACK FOOTER //
// ./src/api/email.js